import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import MessageTemplateForm from "./MessageTemplateForm";
import { useNavigate, useParams } from "react-router-dom";
import useMessageTemplates from "hooks/message-templates/useMessageTemplates";
import { Button, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";

export default function EditMessageTemplate() {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const { fetchTemplateById, updateTemplate } = useMessageTemplates();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTemplate = async () => {
      setLoading(true);
      try {
        const data = await fetchTemplateById(templateId);
        setTemplate(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getTemplate();
  }, [templateId]);

  const normalizeTemplate = (template) => ({
    ...template,
    code: template?.code ?? null,
    clientApp: template?.clientApp ?? null,
    locale: template?.locale ?? null,
    subject: template?.subject ?? "",
    bodyHtml: template?.bodyHtml ?? "",
    bodyText: template?.bodyText ?? "",
  });

  const handleSubmit = async (values) => {
    await updateTemplate(values, templateId);
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: 400 }}
      >
        <Spinner animation="border" variant="success" />
        <span className="ms-3" style={{ fontSize: "13.33px" }}>
          Loading...
        </span>
      </div>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
        <WidgetSectionTitle
          icon="envelope-open-text"
          title="Edit Message Template"
          subtitle={template?.code}
          className="mb-3 mt-3 flex-1"
        />

        <Button
          variant="info"
          size="sm"
          className="text-sm"
          onClick={() => navigate(`/account/message-templates`)}
        >
          Go Back
        </Button>
      </div>

      <MessageTemplateForm
        initialValues={normalizeTemplate(template)}
        onSubmit={handleSubmit}
        submitLabel="Update Template"
        disableCode
      />
    </>
  );
}
